import React, { useCallback, useEffect, useState } from 'react';

export default function ShowInAnimation({ show, transformVariants, duration, ease, className, children }) {
    const [renderingChildren, setRenderingChildren] = useState(show ? "active" : "gone");
    const [transform, setTransform] = useState(show ? transformVariants.in : transformVariants.out);
    const [timeoutId, setTimeoutId] = useState(undefined);

    const clearCall = useCallback(() => {
        if (timeoutId)
            clearTimeout(timeoutId);
    }, [timeoutId]);
    const callLater = useCallback((func, d) => {
        if (timeoutId)
            clearTimeout(timeoutId);
        setTimeoutId(setTimeout(() => {
            func();
        }, d * 1000));
    }, [timeoutId]);

    useEffect(() => {
        if (show) {
            setTransform(transformVariants.in)
        } else {
            setTransform(transformVariants.out)
        }
        switch (renderingChildren) {
            case "gone":
                if (show) {
                    clearCall();
                    setRenderingChildren("hidden");
                    setTransform(transformVariants.out);
                } else {
                    setTransform(transformVariants.out);
                }
                break;
            case "hidden":
                if (show) {
                    setRenderingChildren("active");
                    setTransform(transformVariants.in);
                } else {

                }
                break;
            case "active":
                if (show) {
                    clearCall();
                    setTransform(transformVariants.in);
                } else {
                    setRenderingChildren("hidden");
                    setTransform(transformVariants.out);
                    callLater(() => {
                        setRenderingChildren("gone");
                    }, duration);
                }
                break;
            default:
                break;
        }
    }, [show, renderingChildren, transformVariants, duration, callLater, clearCall]);

    return <div
        style={{
            transform: transform,
            transition: "transform " + String(duration) + "s " + ease
        }}
        className={className}>
        {(renderingChildren !== "gone") ? children : null}
    </div>
}